import './GaugeChartLayout.css';
export var layoutContainer = '_16g2d7p0-2-0-1';